import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import PortfolioPage from "./Pages/PortfolioPage";
import Container from "./Components/Container";
import "./App.css";
import Logo from "./Components/Logo";
import Portfolios from "./Portfolios/Portfolios";
import Menu from "./Components/Menu";
import ClearLine from "./Components/ClearLine";
import {WindowWidthProvider} from "./Context/WindowWidthContext";
import {MobileProvider, useMobile} from "./Context/MobileContext";
import {useState} from "react";
import PortfolioImage from "./Portfolios/Entities/PortfolioImage";
import PageStyle from "./Components/Enums/PageStyle";
import AboutPage from "./Pages/AboutPage";
import ExhibitsPage from "./Pages/ExhibitsPage";
import NewsPage from "./Pages/NewsPage";
import ContactPage from "./Pages/ContactPage";
import {Page} from "./Components/Entities/Page";

function AppContent() {
    const [selectedPortfolioPiece, setSelectedPortfolioPiece] = useState<PortfolioImage | null>(null);
    const {isMobile} = useMobile();

    const pages: Page[] = [
        {
            path: "/",
            aliases: ["*"],
            pageElement: (<PortfolioPage portfolios={Portfolios} selectedPortfolioPiece={selectedPortfolioPiece}
                                         setSelectedPortfolioPiece={setSelectedPortfolioPiece}/>),
            pageStyle: PageStyle.Tan
        },
        {
            path: "/about",
            aliases: ["/about.php"],
            pageElement: (<AboutPage/>),
            pageStyle: PageStyle.Tan,
            containerClassName: "about-page"
        },
        {
            path: "/exhibits",
            aliases: ["/exhibits.php"],
            pageElement: (<ExhibitsPage/>),
            pageStyle: PageStyle.DarkGrey,
            containerClassName: "exhibits-page"
        },
        {
            path: "/news",
            aliases: ["/news.php"],
            pageElement: (<NewsPage/>),
            pageStyle: PageStyle.Gray,
            containerClassName: "news-page"
        },
        {path: "/contact", aliases: ["/contact.php"], pageElement: (<ContactPage/>), pageStyle: PageStyle.Tan},
    ];

    const header = isMobile ? (
        <>
            <Menu selectedPortfolioPiece={selectedPortfolioPiece}/>
            <Logo/>
        </>
    ) : (
        <>
            <Logo/>
            <Menu selectedPortfolioPiece={selectedPortfolioPiece}/>
        </>
    );

    return (
        <BrowserRouter>
            <Container pages={pages} portfolios={Portfolios}>
                <div id="page">
                    {header}
                    <Routes>
                        {pages.map((page) => (
                            <>
                                <Route path={page.path} element={page.pageElement}/>

                                {
                                    // PHP page aliases
                                    page.aliases.map((alias) => (
                                        <Route path={alias} element={
                                            <Navigate to={page.path} replace/>
                                        }/>
                                    ))
                                }

                                <Route path={"/portfolio/*"} element={(<PortfolioPage portfolios={Portfolios}
                                                                                      selectedPortfolioPiece={selectedPortfolioPiece}
                                                                                      setSelectedPortfolioPiece={setSelectedPortfolioPiece}/>)}/>

                                {
                                    // Portfolio PHP aliases
                                    // Portfolios used to be portfolio-human-loss.php now they're /portfolio/human-loss
                                    Portfolios.map(portfolio => (
                                        <Route path={"/portfolio-" + portfolio.path + ".php"} element={
                                            <Navigate to={"/portfolio/" + portfolio.path} replace/>
                                        }/>
                                    ))
                                }
                            </>
                        ))}
                    </Routes>

                    <ClearLine/>
                </div>
            </Container>
        </BrowserRouter>
    );
}

function App() {
    return (
        <WindowWidthProvider>
            <MobileProvider>
                <AppContent/>
            </MobileProvider>
        </WindowWidthProvider>
    );
}

export default App;